import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manhwa';

export default function CategoryNav() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-start gap-6 mb-10">
          <div className="lg:w-1/2">
            <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950 leading-tight">
              分类导航
              <br />
              探索多元韩漫世界
            </h2>
          </div>
          <div className="lg:w-1/2 lg:pt-2">
            <p className="text-sm text-foreground-500 leading-relaxed">
              从热血战斗到浪漫恋爱，从奇幻冒险到宫廷权谋——我们精心整理了六大分类，帮你快速找到心仪的漫画类型，开启你的韩漫阅读之旅。
            </p>
          </div>
        </div>

        {/* Category Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {/* Large Card - First */}
          <Link
            to={`/category/${categories[0].slug}`}
            className="md:col-span-2 group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
          >
            <div className="flex flex-col md:flex-row h-full">
              <div className="md:w-1/2 h-48 md:h-auto overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20battle%20scene%2C%20dynamic%20fantasy%20warrior%20with%20sword%2C%20epic%20manga%20style%20illustration%2C%20vibrant%20red%20and%20orange%20energy%20effects%2C%20dramatic%20lighting%2C%20clean%20webtoon%20art%20style&width=800&height=500&seq=cat-hot-blood&orientation=landscape"
                  alt="热血战斗"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="md:w-1/2 p-6 flex flex-col justify-center">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mb-3">
                  <i className="ri-sword-line text-primary-600 text-lg"></i>
                </div>
                <h3 className="font-heading text-xl font-bold text-foreground-950">{categories[0].name}</h3>
                <p className="text-sm text-foreground-500 mt-2">{categories[0].description}</p>
                <span className="text-xs text-primary-500 font-medium mt-3">{categories[0].count}部作品</span>
              </div>
            </div>
          </Link>

          {/* Right Column - Two Cards */}
          {categories.slice(1, 3).map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="flex flex-col">
                <div className="p-5 flex flex-col items-center text-center">
                  <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mb-3">
                    <i className={`${cat.icon} text-accent-600 text-xl`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{cat.name}</h3>
                </div>
                <div className="h-40 overflow-hidden">
                  {cat.slug === 'romance-school' && (
                    <img
                      src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20school%20scene%2C%20artistic%20webtoon%20illustration%2C%20warm%20soft%20pink%20colors%2C%20clean%20comic%20art%2C%20elegant%20design&width=600&height=400&seq=cat-romance-school&orientation=landscape"
                      alt={cat.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  )}
                  {cat.slug === 'fantasy-adventure' && (
                    <img
                      src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20adventure%20scene%2C%20artistic%20webtoon%20illustration%2C%20warm%20golden%20colors%2C%20clean%20comic%20art%2C%20magical%20design&width=600&height=400&seq=cat-fantasy-adventure&orientation=landscape"
                      alt={cat.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Bottom Row - Remaining Categories */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {categories.slice(3).map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex items-center gap-4 p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-lg bg-secondary-100 flex items-center justify-center shrink-0">
                <i className={`${cat.icon} text-secondary-600 text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h4 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {cat.name}
                </h4>
                <p className="text-xs text-foreground-500 mt-0.5">
                  {cat.description.slice(0, 16)}...
                </p>
              </div>
              <div className="ml-auto text-xs text-foreground-400 whitespace-nowrap">
                {cat.count}部
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}